/*
 * safeHref(url) — the url when it is safe to put in href/src, otherwise undefined.
 * React 18 still renders "javascript:" URLs, so any link built from API data
 * (file links, WhatsApp / tel links, saved uploads) must go through this.
 * Allowed: http(s), mailto, tel, blob, and relative paths / #anchors.
 */
const SAFE_SCHEMES = ["http:", "https:", "mailto:", "tel:", "blob:"];

export const safeHref = (url) => {
  if (url === null || url === undefined || url === "") return undefined;
  const raw = String(url);
  // browsers ignore control characters and whitespace inside the scheme ("java\tscript:")
  // eslint-disable-next-line no-control-regex -- stripping control characters is the point
  const compact = raw.replace(/[\u0000- \u007f-\u009f]/g, "").toLowerCase();
  const scheme = compact.match(/^([a-z][a-z0-9+.-]*):/);
  if (!scheme) return raw; // relative path, ./file.pdf, #anchor, ?query
  return SAFE_SCHEMES.includes(`${scheme[1]}:`) ? raw : undefined;
};

export default safeHref;
